import PropTypes from 'prop-types';
import { useState } from 'react';

const NewTagTypeForm = ({ tagTypeOptions, onAddTagType }) => {
  const [newTagType, setNewTagType] = useState({ id: 0, type: '', isChecked: true });
  const [message, setMessage] = useState('');

  const isDuplicateTagType = (type) => tagTypeOptions.some((tagType) => tagType.type === type);

  const handleNameChange = (e) => {
    const type = e.target.value;
    setNewTagType({ ...newTagType, type });

    setMessage(isDuplicateTagType(type) ? 'This tag type already exists.' : '');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { type } = newTagType;

    if (!type || isDuplicateTagType(type)) return;

    onAddTagType(newTagType);
    setNewTagType({ id: 0, type: '', isChecked: true });
  };

  return (
    <form>
      <input
        type="text"
        value={newTagType.type}
        onChange={handleNameChange}
        placeholder="Enter tag type"
      />
      <button onClick={handleSubmit} disabled={!newTagType.type || isDuplicateTagType(newTagType.type)}>
        Add Tag Type
      </button>
      {message && <div style={{ color: 'red' }}>{message}</div>}
    </form>
  );
};

NewTagTypeForm.propTypes = {
  tagTypeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAddTagType: PropTypes.func.isRequired,
};

export default NewTagTypeForm;
